import React, { useState, useContext } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../SelectValue/FormikControl";
import Button from "../SelectValue/Button";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../SelectValue/Loading";
import Camera from "../../Assets/images/camera.png";
import { UserContext } from "../../Context/UserContext";
import Constant from "../../Constant";
import postService from "../../Services/post-service";
import { toast } from "react-toastify";

function Account() {
  const { userDetails } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const userValue = userDetails || {};
  const [profileImage, setProfileImage] = useState(userValue.profilePicture || Camera);
  const [profileFile, setProfileFile] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  // const dropdownOptions = [
  //   { key: "Select an option", value: "" },
  //   { key: "Male", value: "male" },
  //   { key: "Female", value: "female" },
  // ];

  const initialValues = {
    fName: userValue.firstName,
    lName: userValue.lastName,
    pNum: userValue.phoneNumber,
    gender: userValue.gender,
  };
  const validationSchema = Yup.object({
    fName: Yup.string().required("Required"),
    lName: Yup.string().required("Required"),
    pNum: Yup.string().required("Required"),
    gender: Yup.string().required("Required"),
  });
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        const rawBase64 = fileReader.result.split(",")[1] || fileReader.result;
        resolve(rawBase64);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      let base64String = "";
      if (profileFile) {
        base64String = await convertToBase64(profileFile);
      }
      const response = await postService.updateUserProfile(base64String, values.pNum);
      if (response.data?.statusCode === 200) {
        toast.success(response.data?.description || "Profile updated successfully");
        setIsEditing(false);
        setProfileFile(null);
      } else {
        toast.error(response.data?.description || "Failed to update profile");
      }
    } catch (error) {
      toast.error(error.response?.data?.description || "Failed to update profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <Loading open={loading} />
      <div className=" ">
        <div className=" flex gap-5">
          {/* profile picture upload */}
          <div className="relative w-24 h-24 rounded-full overflow-hidden border-2 border-gray-200 cursor-pointer">
            <label
              htmlFor="profile-upload"
              className="cursor-pointer w-full h-full block"
            >
              <img
                src={profileImage}
                alt="Profile"
                className="w-full h-full object-cover"
              />
              {/* <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                <span className="text-white text-xs font-semibold">Upload</span>
              </div> */}
            </label>
            <input
              id="profile-upload"
              type="file"
              accept="image/*"
              className="hidden"
              disabled={!isEditing}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  setProfileImage(URL.createObjectURL(file));
                  setProfileFile(file);
                }
              }}
            />
          </div>
          <div className=" flex flex-col justify-center">
            <p className=" text-[24px] font-[500] leading-[150%] text-back-color2">
              {Constant.convertToTitleCase(userValue.firstName)}{" "}
              {Constant.convertToTitleCase(userValue.lastName)}
            </p>
          </div>
        </div>

        <div className="  mt-5">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={true}
          >
            {(formik) => (
              <Form>
                <div className=" my-4 md:grid grid-cols-4 gap-5">
                  <div className=" flex flex-col justify-center">
                    <p className="text-[#1C1B1F] font-semibold text-[16px]">
                      Full name
                    </p>
                  </div>

                  <FormikControl
                    control="input"
                    type="text"
                    label="First name"
                    name="fName"
                    disabled={!isEditing}
                  />

                  <FormikControl
                    control="input"
                    type="text"
                    label="Last name"
                    name="lName"
                    disabled={!isEditing}
                  />
                </div>
                <div className=" my-4 md:grid grid-cols-4 gap-5">
                  <p className="text-[#1C1B1F] font-semibold text-[16px]">
                    Phone number
                  </p>
                  <div className=" col-span-2">
                    <FormikControl
                      control="input"
                      type="tel"
                      label="Phone number"
                      name="pNum"
                      disabled={!isEditing}
                    />
                  </div>
                </div>


                {/* gender */}
                <div className=" my-4 md:grid grid-cols-4 gap-5">
                  <p className="text-[#1C1B1F] font-semibold text-[16px]">
                    Gender
                  </p>
                  <div className=" col-span-2">
                    <FormikControl
                      control="input"
                      type="text"
                      label="Gender"
                      name="gender"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className=" md:grid grid-cols-4 mb-5 mt-6">
                  <div></div>
                  <div className=" col-span-2 flex gap-4">
                    {!isEditing ? (
                      <button
                        type="button"
                        onClick={() => setIsEditing(true)}
                        className="bg-primary-color w-full px-4 py-2 border-none rounded-lg font-bold text-white"
                      >
                        Edit
                      </button>
                    ) : (
                      <>
                        <div className="w-1/2">
                          <Button
                            name="Save changes"
                            bool={true}
                            disabled={!formik.dirty && !profileFile}
                            isLoading={loading}
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            formik.resetForm();
                            setProfileImage(userValue.profilePicture || Camera);
                            setProfileFile(null);
                            setIsEditing(false);
                          }}
                          className="w-1/2 border border-primary-color text-primary-color bg-white px-4 py-2 rounded-lg font-bold"
                        >
                          Cancel
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default Account;
